export default "__VITE_ASSET__8ea1225c__"